// SPDX-License-Identifier: Apache-2.0

import React from "react";

/**
 * Displays the deployed version using the environment variables.
 * @constructor
 */
export function FAQPage() {
  return (
    <div>
      <h2>What are confidential NFTs (cNFTs)?</h2>
      Normal NFTs have additional metadata associated with them that is readable
      by everyone. In many cases this is desireable, but not always.
      Confidential NFTs allow hiding some of these metadata fields (for example
      a higher resolution image) such that they can only be read by the current
      owner.
      <h2>Who can access the confidential data?</h2>
      Only the current owner of the NFT. Previous owners can still read it if
      they stored the key locally, this is unavoidable and he could also just
      have stored the data before selling the NFT.
      <h2>How is its integrity protected?</h2>
      The data is AES-GCM encrypted and stored in the metadata json. As long as
      the metadata json is integrity protected (e.g. by storing its hash
      on-chain or using IPFS), the confidential data is known to be authentic.
      <h2>Does it still work when this site goes offline?</h2>
      The decryption key is stored in two places:
      <ul>
        <li>
          The keyserver, which allows retrieving the key even if the previous
          owner is offline.
        </li>
        <li>In your browsers local storage.</li>
      </ul>
      Additionally you can export this key and store it offline.
      <p>
        If the Keyserver goes offline the data can still be decrypted by the
        current owner as long as the key still is in his browser (or available
        offline). But when selling the cNFT the new owner has to rely on the old
        owner to send him the decryption key.
      </p>
      <p>
        If this website goes offline the data is still secure and accessible (as
        long as you have the decryption key stored or can still access the
        keyserver). There is nothing that prevents someone else to host an
        interface similar to this site, thus allowing the cNFTs to be decrypted
        with less effort again.
      </p>
      <h2>Where is the data stored?</h2>
      The confidential data is stored together with the public metadata in a
      json file. This file can be hosted anywhere, usually in IPFs or on a
      normal Webserver/AWS. Images can also be stored on your own webserver,
      with the user authenticating himself by knowing the URL stored in the
      confidential metadata.
      <h2>Can I use my collections/code?</h2>
      Yes. The only restriction is that the NFTs must store their metadata in
      the (standardized) JSON format that contains two extra cNFT fields:
      "key_id" and "encrypted". The contract logic is up to the deployer, though
      this web-interface currently does not support creating such collections or
      minting tokens on them.
      <h2>Does this work with OpenSea?</h2>
      Yes. Condidential fields can be left out (not visible on OpenSea) or set
      to a public value that should be displayed on NFT explorers that are not
      aware of confidential NFTs and for users that currently do not own the
      token.
      <h2>Can the access restrictions be changed to suite my needs?</h2>
      Yes. The backend/enclave is flexible and allows many ways to restrict
      access (e.g. password based, arbitrary logic via smart contract code). But
      this cannot be done through this website and requires custom logic for
      creating and accessing these (using the keyserver-client SDK).
      <h2>
        How can I know the confidential data is correct before buying a cNFT?
      </h2>
      You cannot. By design this data is only accessible by the current owner.
      The NFT minter is free to choose the data stored in the confidential part.
      In the future we might add a way to check some statements about the
      confidential data, but this can only be done to some extend.
    </div>
  );
}
